import { authApiCall } from '../auth/saga';

export const getRecommendedList = (location, params) => {
  return authApiCall({
    url: '/users/recommended-business-list/',
    method: 'post',
    data: {
      location,
    },
    params,
  });
};

export const getAllList = params => {
  return authApiCall({
    url: '/users/all-business-list/',
    method: 'get',
    params,
  });
};

export const getDetail = id => {
  return authApiCall({
    url: `/users/business-detail-copy/${id}/`,
    method: 'get',
  });
};

export const getBusinessCoupons = id => {
  return authApiCall({
    url: `/users/business-coupons/${id}/`,
    method: 'get',
  });
};

export const getAffiliateBusinessCoupons = id => {
  return authApiCall({
    url: `/coupons/affiliate-business-coupons/${id}/`,
    method: 'get',
  });
};

export const followBusiness = data => {
  const { is_affiliate_or_flyer = false, ...rest } = data;

  return authApiCall({
    url: '/users/follow-business/',
    method: 'post',
    data: {
      ...rest,
      is_affiliate_or_flyer: !!is_affiliate_or_flyer,
    },
  });
};

export const unfollowBusiness = data => {
  return authApiCall({
    url: '/users/unfollow-business/',
    method: 'delete',
    data,
  });
};

export const getFollowedBusinesses = params => {
  return authApiCall({
    url: '/users/list-user-follows/',
    method: 'get',
    params,
  });
};